import styled from 'styled-components';

import { media } from '@/shared/components';

export const Container = styled.div`
  display: flex;
  gap: 12px;
  height: 100%;
  width: 100%;
`;

export const Sidebar = styled.div`
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: 100%;
  overflow: hidden;

  ${media.mobile} {
    display: none;
  }
`;

export const Thumbnail = styled.div`
  width: 100%;
  height: 180px;
  min-height: 180px;
  opacity: 0.2;
  background: linear-gradient(80deg, #fff 25%, #ffffffcc 37%, #fff 63%);
  background-size: 400% 100%;
  animation-name: skeleton-loading;
  animation-duration: 2s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;

  @keyframes skeleton-loading {
    0% {
      background-position-x: 100%;
    }

    70%,
    100% {
      background-position-x: 0%;
    }
  }
`;

export const Main = styled.div`
  flex-grow: 6;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LayoutSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid #d0d4dc;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    width: 16px;
    height: 16px;
    transform: translate(-50%, 50%);
    border-radius: 50%;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
